// src/utils/media.ts

const RAW_API_URL = process.env.REACT_APP_API_URL || "";
export const API_URL = RAW_API_URL.replace(/\/+$/, "");

export const FALLBACK_IMG = "/images/placeholder.jpg";

/**
 * Resolve image url giống project cũ (safe hơn):
 * - null / undefined -> placeholder
 * - http(s):// -> giữ nguyên
 * - //domain.com/a.webp -> thêm https:
 * - domain.com/a.webp (không có protocol) -> thêm https:
 * - \uploads\a.webp -> normalize
 * - /uploads/a.webp -> API_URL + path
 * - uploads/a.webp  -> API_URL + /path
 */
export function resolveImg(url?: string | null): string {
  if (!url) return FALLBACK_IMG;

  const u = String(url).replaceAll("\\", "/").trim();
  if (!u) return FALLBACK_IMG;

  // already absolute http(s)
  if (/^https?:\/\//i.test(u)) return u;

  // protocol-relative: //domain/path
  if (u.startsWith("//")) return `https:${u}`;

  // looks like domain/path but missing protocol
  // e.g. api.jjsnake.com/uploads/a.webp
  if (/^[a-z0-9.-]+\.[a-z]{2,}(\/|$)/i.test(u)) {
    return `https://${u}`;
  }

  // relative path -> prepend API_URL if available
  if (!API_URL) return u;

  if (u.startsWith("/")) return `${API_URL}${u}`;
  return `${API_URL}/${u}`;
}
